import { Box, Link } from '@mui/material'
import React from 'react'
import { grey } from '../../../colors'
import { genericWizardHeaderTooltipFields, uploadCSVTemplatePaths } from '../constants'

const downloadTemplateLink = (href: string): JSX.Element => {
  return (
    <Box>
      Need a template? <Link href={href} download color={grey[0]}>Click here!</Link>
    </Box>
  )
}

const facultyTooltipText = (
  <>
    {downloadTemplateLink(uploadCSVTemplatePaths.faculty)}<br />
    {genericWizardHeaderTooltipFields.requiredFieldText}<br />
    {genericWizardHeaderTooltipFields.firstName}<br />
    {genericWizardHeaderTooltipFields.lastName}<br />
    {genericWizardHeaderTooltipFields.email}<br />
    {genericWizardHeaderTooltipFields.id}<br />
    {genericWizardHeaderTooltipFields.password}<br /><br />
    {genericWizardHeaderTooltipFields.optionalFieldText}<br />
    {genericWizardHeaderTooltipFields.userAttributes}<br />
  </>
)

const studentsTooltipText = (
  <>
    {downloadTemplateLink(uploadCSVTemplatePaths.students)}<br />
    {genericWizardHeaderTooltipFields.requiredFieldText}<br />
    {genericWizardHeaderTooltipFields.firstName}<br />
    {genericWizardHeaderTooltipFields.lastName}<br />
    {genericWizardHeaderTooltipFields.email}<br />
    {genericWizardHeaderTooltipFields.id}<br />
    {genericWizardHeaderTooltipFields.password}<br />
  </>
)

const coursesTooltipText = (
  <>
    {downloadTemplateLink(uploadCSVTemplatePaths.courses)}<br />
    {genericWizardHeaderTooltipFields.requiredFieldText}<br />
    {genericWizardHeaderTooltipFields.courseTitle}<br />
    {genericWizardHeaderTooltipFields.abbreviation}<br />
    {genericWizardHeaderTooltipFields.parentAcademicUnit}<br /><br />
    {genericWizardHeaderTooltipFields.optionalFieldText}<br />
    {genericWizardHeaderTooltipFields.academicUnitType}<br />
  </>
)

const courseSectionsTooltipText = (
  <>
    {downloadTemplateLink(uploadCSVTemplatePaths.courseSections)}<br />
    {genericWizardHeaderTooltipFields.requiredFieldText}<br />
    {genericWizardHeaderTooltipFields.abbreviation}<br />
    {genericWizardHeaderTooltipFields.sectionId}<br />
    {genericWizardHeaderTooltipFields.courseTitle}<br />
    {genericWizardHeaderTooltipFields.startDate}<br />
    {genericWizardHeaderTooltipFields.endDate}<br /><br />
    {genericWizardHeaderTooltipFields.optionalFieldText}<br />
    {genericWizardHeaderTooltipFields.term}<br />
    {genericWizardHeaderTooltipFields.crossListCode}<br />
    {genericWizardHeaderTooltipFields.isPrimaryCourse}<br />
    {genericWizardHeaderTooltipFields.courseAttributes}<br />
  </>
)

const instructorAssignmentsTooltipText = (
  <>
    {downloadTemplateLink(uploadCSVTemplatePaths.instructorAssignments)}<br />
    {genericWizardHeaderTooltipFields.requiredFieldText}<br />
    {genericWizardHeaderTooltipFields.email}<br />
    {genericWizardHeaderTooltipFields.academicUnit}<br /><br />
    {genericWizardHeaderTooltipFields.optionalFieldText}<br />
    {genericWizardHeaderTooltipFields.role}<br />
    {genericWizardHeaderTooltipFields.term}<br />
  </>
)

const studentEnrollmentsTooltipText = (
  <>
    {downloadTemplateLink(uploadCSVTemplatePaths.studentEnrollments)}<br />
    {genericWizardHeaderTooltipFields.requiredFieldText}<br />
    {genericWizardHeaderTooltipFields.email}<br />
    {genericWizardHeaderTooltipFields.academicUnit}<br /><br />
    {genericWizardHeaderTooltipFields.optionalFieldText}<br />
    {genericWizardHeaderTooltipFields.role}<br />
    {genericWizardHeaderTooltipFields.term}<br />
  </>
)

export {
  facultyTooltipText,
  studentsTooltipText,
  coursesTooltipText,
  courseSectionsTooltipText,
  instructorAssignmentsTooltipText,
  studentEnrollmentsTooltipText
}
